import * as basicScroll from "basicscroll";

const confettis = document.querySelectorAll("[data-confettis]");
const confettisInstances = [];

confettis.forEach(confetti => {
  const property = `--${confetti.dataset.confettisAnimate}`;
  const from = confetti.dataset.confettisFrom;
  const to = confetti.dataset.confettisTo;

  confettisInstances.push(basicScroll
    .create({
      elem: confetti,
      from: "top-bottom",
      to: "top-top",
      direct: true,
      props: {
        [property]: {
          from: from,
          to: to
        }
      }
    }));
});

export default confettisInstances;
